import { Point } from 'geojson';

export class CircleRequest {
  point: Point;
  distanceMiles: number;
}
